import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'cancel',
    position: [
        ButtonPosition.dialog,
        ButtonPosition.formDialog,
        ButtonPosition.form,
        ButtonPosition.blockButton,
    ],
    action: ({ buttonConfig, close }) => {
        if (buttonConfig) {
            close && close();
        }
    },
};
